module.exports = __webpack_public_path__ + "img/bni_va.44c10579.svg";